import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { AuthReducer, AuthState } from "./auth-reducer";
import { OrderReducer, OrderState } from "./order-reducer";
import { WarehousesReducer, WarehousesState } from "./warehouses-reducer";

export interface ApplicationState {
  auth: AuthState;
  warehouses: WarehousesState;
  order: OrderState;
}

// combineReducers will be handled internally by configureStore
const reducer = combineReducers({
  auth: AuthReducer,
  warehouses: WarehousesReducer,
  order: OrderReducer,
});

//const preloadedState = {};
export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  devTools: process.env.NODE_ENV !== "production",
  //preloadedState,
  //enhancers: [batchedSubscribe(debounceNotify)],
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
